import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { FileText, FileSignature, BookOpen, PieChart, Layout, Send } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Document Generator — Proposals, Contracts & Reports in Seconds
  Meta Desc: MISTR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send. Zero manual writing.
  Primary KW: AI document generator for business
*/
export function DocumentGenerator() {
  return <FeaturePageLayout seoTitle="Document Generator — Proposals & Contracts | MindStream.ing" seoDesc="MISTR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send. Zero manual writing." heroEyebrow="DOCUMENT GENERATOR" heroTitle={<>
          Documents That{' '}
          <span className="text-gradient" data-id="element-1552">Write Themselves.</span>
        </>} heroDesc="MR generates proposals, contracts, SOPs, and reports automatically — in your brand voice, formatted perfectly, ready to send." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Request',
      desc: 'Tell MR what document you need via voice or text.'
    }, {
      title: 'Generate',
      desc: 'MR pulls context and generates the document instantly.'
    }, {
      title: 'Send',
      desc: 'Review, approve, and send — or let MR auto-send it.'
    }]
  }} problem={{
    subtitle: 'Document creation is tedious. Proposals take hours. Contracts need customization. Reports are manual.',
    cards: [{
      icon: <FileText size={32} data-id="element-1553" />,
      title: 'Wasted Hours',
      desc: 'You spend your evenings copying and pasting from old proposals, trying to make the formatting match.'
    }, {
      icon: <FileSignature size={32} data-id="element-1554" />,
      title: 'Costly Errors',
      desc: "You forget to change a client's name in a contract template, looking unprofessional and risking the deal."
    }]
  }} features={{
    cards: [{
      icon: <FileText size={24} data-id="element-1555" />,
      title: 'Proposal Generation',
      desc: 'Creates highly customized, persuasive proposals based on your sales calls.'
    }, {
      icon: <FileSignature size={24} data-id="element-1556" />,
      title: 'Contract Creation',
      desc: 'Drafts accurate agreements with the correct names, dates, and terms.'
    }, {
      icon: <BookOpen size={24} data-id="element-1557" />,
      title: 'SOP Templates',
      desc: 'Turns your voice notes into step-by-step standard operating procedures.'
    }, {
      icon: <PieChart size={24} data-id="element-1558" />,
      title: 'Report Automation',
      desc: 'Pulls data from your tools to create beautiful weekly or monthly reports.'
    }, {
      icon: <Layout size={24} data-id="element-1559" />,
      title: 'Brand Formatting',
      desc: 'Ensures every document uses your exact fonts, colors, and logos.'
    }, {
      icon: <Send size={24} data-id="element-1560" />,
      title: 'One-Click Send',
      desc: 'Emails the document directly to the client with a personalized message.'
    }]
  }} data-id="element-1551" />;
}